<!-- 这是传入图片，当作背景的操作 -->
<template>
  <div :style="computedStyle" class="s-com select-com">
    <div class="show-label" v-if="label">{{ label }}</div>
    <div class="show-text">{{ show_text }}</div>
    <div :style="popoupStyle" class="op-com">
      <div class="op-wrapper">
        <div
          class="op-item"
          v-for="(item, index) in op"
          :key="index"
          @click="selectItem(item.value)"
        >
          {{ item.text }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import config from '@img/config.json';
const { support_image, is_mobile } = inject('GlobalStore');
import px2vw from '@/utils/px2vw_v2';

const props = defineProps({
  selectValue: {
    type: String,
    required: true,
  },
  src: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
  size: {
    type: Object,
    required: false,
  },
  op: {
    type: Object,
    default: () => [],
  },
});

const emit = defineEmits(['update:selectValue', 'opChange']);

const bg = ref();

const computedStyle = computed(() => {
  var size = null;
  if (props.size) {
    size = props.size;
  } else {
    size = config[props.src];
  }
  return {
    backgroundImage: `url(${bg.value})`,
    backgroundRepeat: 'round',
    width: px2vw(size.width, is_mobile.value),
    height: px2vw(size.height, is_mobile.value),
  };
});

const popoupStyle = computed(() => {
  var size = null;
  if (props.size) {
    size = props.size;
  } else {
    size = config[props.src];
  }
  let bg = `${config['xialakuan-menpai'].src}.${support_image.value}`;

  return {
    'border-image-source': `url(${bg})`,
    width: px2vw(200, is_mobile.value),
    'border-image-slice': '40 40 45 64 fill',
    'border-image-width': '40px 40px 45px 64px',
  };
});

const show_text = computed(() => {
  const result = props.op.find((item) => item.value == props.selectValue);

  return result?.text;
});

const selectItem = (_value) => {
  console.log('selectItem', _value, props.selectValue);
  if (_value == props.selectValue) {
    // 如果点击的是当前选中的，就不做任何操作
    return;
  }
  emit('update:selectValue', _value);
  emit('opChange', _value);
};

const handleScroll = (event) => {
  event.preventDefault();
  event.stopPropagation();
  console.log('handleScroll', event);
};

onMounted(async () => {
  let src = config[props.src].src;
  bg.value = `${src}.${support_image.value}`;
});
</script>

<!-- <style  lang="scss" scoped>
.select-container {
  position: relative;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: top;

  &:hover {
    .op-com {
      display: block;
    }
  }
}

.select-com {
  font-size: 18px;
}

.op-com {
  position: absolute;
  display: none;
  right: 0px;
  top: 38px;
  z-index: 10000;
  max-height: 500px;
  overflow: auto;
}

.op-item {
  width: 100%;
  display: block;
  line-height: 40px;

  &:hover {
    background-color: #0f1d7a;
  }
}

.show-text {
  position: absolute;
  right: 50px;
  top: 0;
  width: 114px;
  line-height: 38px;
  text-align: center;
}

.show-label{
  // position: absolute;
  right: 0;
  width: 134px;
  line-height: 38px;
  text-align: center;
}

.op-wrapper {
  padding: 8px;
}
</style> -->
